import { NgModule } from '@angular/core';
import { CoreComponent } from './core.component';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  declarations: [CoreComponent],
  imports: [
    MatSnackBarModule
  ],
  exports: [CoreComponent, MatSnackBarModule]
})
export class CoreModule { }
